export enum DamageSection {
  Zone = 'zone',
  Component = 'component',
  Fault = 'fault',
}
